// OWNER: HELP. Help center: start-here path, sections, and search.
import { createFileRoute } from '@tanstack/react-router'
import { HelpCenter } from '@/help/HelpCenter'

export const Route = createFileRoute('/help/')({
  validateSearch: (s: Record<string, unknown>): { q?: string } => ({
    q: typeof s.q === 'string' && s.q.trim() ? s.q : undefined,
  }),
  component: HelpCenterRoute,
})

function HelpCenterRoute() {
  const { q } = Route.useSearch()
  return <HelpCenter q={q ?? ''} />
}
